<template lang="pug">
	.timeline-message-players
		player-card(
			v-for="(player, index) in players"
			v-if="player"
			:key="player._id"
			:player="player"
			:backup-crest="crest"
			:icon="iconForPlayer(player, index)"
		)
</template>

<script>
import PlayerCard from './PlayerCard'
import substitutionOutIcon from './../assets/img/icons/substitution-out.svg'
import substitutionInIcon from './../assets/img/icons/substitution-in.svg'
export default {
	components: {
		PlayerCard
	},
	props: {
		players: Array,
		action: String,
		crest: String
	},

	methods: {
		iconForPlayer (player, index) {
			if (this.action === 'substitution') {
				if (index === 0) {
					return substitutionOutIcon
				} else if (index === 1) {
					return substitutionInIcon
				}
			}
			return null
		}
	}
}

</script>

<style lang="scss" scoped>
	.timeline-message-players {
		display: flex;
		flex-wrap: wrap;
	}
	.player-card {
		margin-right: 1em;
		margin-top: 1em;
	}
</style>
